import React from "react";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Row,
  Col,
  Stack,
} from "react-bootstrap";
import "./Navbar.css"; // Import custom CSS
import { NavLink, useLocation } from "react-router-dom";

const LoginNavbar = () => {
  return (
    <>
      <div>
        <Container fluid className="nav-container pt-3 pb-3">
          <Row style={{ width: "90%", marginTop: "10px", marginLeft: "auto", marginRight: "auto" }} >
            <div style={{ width: "100%", display: "flex",padding:12 }}>
              <div style={{ flex: 1 }}>
                <div style={{ textAlign: "start" }}>
                  <img style={{ width: 150 }} src={"/images/logo.png"} />
                </div>
              </div>
              <div style={{ justifyContent: "end", flex: 1 }} >
                <div style={{ display: "flex", justifyContent: "end", marginRight: 10 }}>
                  <div className="profile-image me-2 mt-1 overflow-hidden">
                    <img
                      style={{ width: "90%" }}
                      src={require("../../assets/flag_of_uk.png")}

                    />
                  </div>
                  <span style={{fontWeight:600}} className="text-light  me-2 mt-2">EN</span>
                </div>
              </div>
            </div>
          </Row>
        </Container>
        <Navbar bg="" expand="lg" className="nav-container" style={{ fontSize: 16 }}>
          <Container>
            <Navbar.Toggle
              aria-controls="basic-navbar-nav"
              className="text-light bg-light"
            />
            <Navbar.Collapse
              id="basic-navbar-nav"
              className="justify-content-center"
            >
              <Nav style={{ height: 30 }} className="me-auto ms-auto d-flex justify-content-around w-100">
                <NavLink
                  to="/"
                  style={{ color: "292d2e !important" }}
                  className={({ isActive }) =>
                    isActive
                      ? "text-primary-xk fw-bold text-decoration-none"
                      : "text-light fw-bold hover-nav-item-color text-decoration-none"
                  }
                >
                  Main Page
                </NavLink>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>

    </>
  );
};

export default LoginNavbar;
